export default class PaymentTypeHandler {
  constructor(paymentType) {
    this.paymentType = paymentType?.toLowerCase() || "donation";
  }

  capitalized() {
    return this.paymentType.charAt(0).toUpperCase() + this.paymentType.slice(1);
  }

  plural(capitalize) {
    switch (this.paymentType) {
      case "donation":
        return capitalize ? "Donations" : "donations";
      case "payment":
        return capitalize ? "Payments" : "payments";
      case "gift":
        return capitalize ? "Gifts" : "gifts";
      default:
        return capitalize ? "Donations" : "donations";
    }
  }

  asVerb(capitalize) {
    switch (this.paymentType) {
      case "donation":
        return capitalize ? "Donate" : "donate";
      case "payment":
        return capitalize ? "Pay" : "pay";
      case "gift":
        return capitalize ? "Give" : "give";
      default:
        return capitalize ? "Donate" : "donate";
    }
  }
}
